import { api } from '../../../../services/api'

export async function gerarGpt({ cidade, campo }) {
  const response = await api.get('cidades-home/gerar-conteudo-gpt-cidade', {
    params: {
      campo: campo,
      nome_cidade: cidade,
    },
  })

  return response.data
}
